import { Injectable, inject } from '@angular/core'
import { AuthBridge } from '@crewdle/auth-bridge'
import { WhiteLabelService } from '@crewdle/white-label/angular'
import { getAuth } from 'firebase/auth'
import { getFirebaseApp } from '../firebase'
import { environment } from '../../../environments/environment'

/**
 * Holds the shared-session bridge to the centralized auth service
 * (auth.crewdle.ai). Used by the auth guard to silently bootstrap a local
 * Firebase session from the `.crewdle.ai` cookie, or redirect to login.
 */
@Injectable({ providedIn: 'root' })
export class AuthBridgeService {
  private readonly whiteLabel = inject(WhiteLabelService)

  readonly bridge = new AuthBridge({
    auth: getAuth(getFirebaseApp()!),
    // A getter, not a plain string: on a partner's custom domain, this
    // resolves to the partner's own auth origin (`domains/{hostname}` →
    // `authDomain`) instead of always hitting the default auth.crewdle.ai.
    // AuthBridge evaluates and awaits it on every use.
    authBaseUrl: () => this.whiteLabel.authBaseUrl(environment.authBaseUrl),
  })

  /** Returns the current Firebase ID token for API/proxy calls, when signed in. */
  async getIdToken(): Promise<string | undefined> {
    return await getAuth(getFirebaseApp()!).currentUser?.getIdToken()
  }
}
